import { objectFilter } from '../filter';

/**
 * Removes any properties that have falsy values from obj
 */
export function objectFilterFalsy<T extends object>(obj: T): T {
  return objectFilter(obj, (key, value) => {
    if (!value) {
      return false;
    }

    return true;
  });
}
